import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection, Field, formatTime } from './shared';

interface Props {
  data: any[];
}

export default function SafetyMeetingsSection({ data }: Props) {
  const totalAttendees = data.reduce((sum, r) => sum + (r.attendee_count ?? 0), 0);

  return (
    <section>
      <SectionHeading id="section-safety-meetings" title="Safety Meetings" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="safety meetings" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <Badge variant="outline">
                    {(row.meeting_type ?? '').replace(/_/g, ' ')}
                  </Badge>
                </div>
                <p className="mb-3 text-sm font-medium">{row.topic}</p>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                  <Field label="Time" value={formatTime(row.meeting_time)} />
                  <Field
                    label="Duration"
                    value={row.duration_minutes != null ? `${row.duration_minutes} min` : null}
                  />
                  <Field label="Attendees" value={row.attendee_count} />
                  <Field label="Conducted By" value={row.conducted_by} />
                  {row.key_points && (
                    <div className="col-span-full">
                      <Field label="Key Points" value={row.key_points} />
                    </div>
                  )}
                  <Field label="Activity" value={row.activity_description} />
                  {row.comments && (
                    <div className="col-span-full">
                      <Field label="Comments" value={row.comments} />
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
          <p className="text-xs text-muted-foreground">
            Total attendees across all meetings: <strong>{totalAttendees}</strong>
          </p>
        </div>
      )}
    </section>
  );
}
